import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks
 * Only allows safe tags and attributes for rich text content
 */
export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'b',
      'em',
      'i',
      'ul',
      'ol',
      'li',
      'a',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'blockquote',
      'span',
      'div',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
    // Force all links to open in new tab with security attributes
    RETURN_DOM: false,
    RETURN_DOM_FRAGMENT: false,
  });
}

/**
 * Sanitize HTML and add security attributes to links
 */
export function sanitizeHtmlWithSecureLinks(html: string): string {
  const sanitized = sanitizeHtml(html);
  // Add rel="noopener noreferrer" to all links for security
  return sanitized.replace(
    /<a\s+([^>]*href=[^>]*)>/gi,
    '<a $1 rel="noopener noreferrer" target="_blank">'
  );
}
